// extracted by mini-css-extract-plugin
export default {"rate":"Rate_rate__agKHy","rating":"Rate_rating__PeaeA"};